<template>
<div class="page-wrapper">
  <search-list
   :projectList = "projectList"
    @findData="findData">
  </search-list>
  <div class="page-wrapper">
  <table-list
    :columns="columns"
    :data="tableData"
    :total="total"
    :current="current"
    :loading="loading"
    @change-page="changePage"
  >
    </table-list>
  </div>
    <confirm-modal :n = "deleteKey" :action="'要作废此应收账单，作废后将无法恢复'"  @cancel = "deleteCertificate"></confirm-modal>
</div>

</template>

<script type="text/ecmascript-6">

import { getList,deleteCertificate } from 'api/paymentVoucher'
import SearchList from './components/SearchList';
import TableList from 'components/TableList/index';
import ConfirmModal from 'components/CancelModal/index';
import {formatMoney} from '@/utils/format'

export default {
  name:'paymentvoucher',
  components:{
    SearchList,
    TableList,
    ConfirmModal
  },
  created(){
  },

  data () {
    return {
      loading:false, // true
      total:0,
      current:1,
      confirmKey:0,
      deleteKey:0,
      periods:1,
      billNumber:'',
      fCode:'',
      projectList:[],
      searchData:{
        projectFid:'',
        startPayDate:'',
        endPayDate:'',
        receiptStatus:'',
        confirmStatus:'',
        contractCode:'',
        billNum:'',
        stockFid:'',
        limit: 10,
        page: 1
      },
      columns:[
        {
          type:'index',
          width:60,
          align:'center'
        },
        {
          title:' '
        },
        {
          title:'缴费凭证单号',
          key:'receiptNum',
          align:'center',
          width:200,
          render: (h,params) => {
            return h('a',{
              on:{
                click:()=>{
                  this.$router.push({name: 'certificatedetail', query: {proId: params.row.projectFid,bNum: params.row.receiptNum}})
                }
              }
            }, params.row.receiptNum)
          }
        },
        {
          title:' '
        },
        {
          title:'合同号',
          key:'outContractCode',
          align:'center',
          width:180
        },
        {
          title:' '
        },
        {
          title:'项目名称',
          key:'projectName',
          align:'center',
          width:160
        },
        {
          title:' '
        },
        {
          title:'房间/床位号',
          key:'stockNumber',
          align:'center',
          width:120
        },
        {
          title:' '
        },
        {
          title:'单据状态',
          key:'receiptStatusName',
          align:'center',
          width:120
        },
        {
          title:' '
        },
        {
          title:'审核状态',
          key:'confirmStatusName',
          align:'center',
          width:90
        },
        {
          title:' '
        },
        {
          title:'收款金额',
          key:'totalAmount',
          align:'center',
          width:120,
          render: (h,params) => {
            let totalAmount = (params.row.totalAmount/100).toFixed(2)
            return h('div',
            {
              style:{
                'text-align':'right'
               }
             },
             formatMoney(totalAmount))
          }
        },
        {
          title:' '
        },
        {
          title:'支付方式',
          key:'paymentTypeCodeName',
          align:'center',
           width:120
        },
        {
          title:' '
        },
        {
          title:'支付时间',
          key:'payTime',
          align:'center',
           width:160
        },
        {
          title:' '
        },
        {
          title:'制单日期',
          key:'createTime',
          align:'center',
          width:160
        },
        {
          title:' '
        },
        {
          title:'操作',
          key:'action',
          align:'center',
          fixed: 'right',
          width:100,
          render:(h,params) => {
            return  h('div',[h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'certificate/invalid'
                  }
                }
              ],
              style:{
                display:(params.row.receiptStatus == 1 || params.row.receiptStatus == 2) && params.row.confirmStatus!==5 && params.row.paymentTypeCode !=='card' ? 'inline-block':'none',
                marginRight: '5px'
              },
              on:{
                click: () => {
                  this.billNumber = params.row.receiptNum
                  this.fCode = params.row.outContractCode
                  this.deleteKey++
                }
              }
            },'作废'),
              h('a',{
                style:{
                  display:(params.row.receiptStatus == 1 || params.row.receiptStatus == 2)
                  && params.row.confirmStatus!==5 && params.row.paymentTypeCode !=='card'
                  &&(params.row.paymentTypeCode.indexOf('yhzz')!=-1||params.row.paymentTypeCode.indexOf('pos')!=-1)
                  && params.row.subjectType == 1 ? 'inline-block':'none',
                  marginRight: '5px'
                },
                on:{
                  click:()=>{
                    this.$router.push({name: 'certificateedit', query: {proId: params.row.projectFid,bNum: params.row.receiptNum,cCode:params.row.outContractCode}})
                  }
                }
              }, '修改')
              ]
            )
          }
        }
      ],
      tableData:[]
    };
 },
 methods:{
   changePage(n){
      this.loading  = true
      this.current = n;
      this.searchData.page = n
      this.getList(this.searchData)
    },
    deleteCertificate(){
      deleteCertificate(this.billNumber,this.fCode).then(res => {
        this.$Message.success('作废缴费凭证成功!');
        this.findData(this.searchData)
      })
    },
    findData(data){
      this.current = 1
      this.searchData = data
      this.searchData.page = 1
      this.getList(this.searchData)
    },
    getList(data){
      this.loading = true
      getList(data).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total
        this.loading = false
      })
    }
 }
}
</script>
